export default __webpack_public_path__ + "static/media/kitchen5-beforeE-1920w.31c24ea5.png";